import PropTypes from "prop-types"
import { useContext } from "react"
import { MultiContext } from "~/contexts/MultiContext"
import { PlainFrame } from "~/components/Single/Frame"

Placeholder.propTypes = {
  position: PropTypes.number.isRequired,
}
export function Placeholder({ position }) {
  const {
    gridConfig,
    dimensions: { normal: normalDimensions, large: largeDimensions },
  } = useContext(MultiContext)
  const large = gridConfig.large.includes(position)
  const placeholderDimensions = large ? largeDimensions : normalDimensions

  return (
    <PlainFrame position={position}>
      <div
        style={placeholderDimensions}
        className="flex items-center justify-center bg-neutral-900 transition-all duration-500"
      >
        <span className="text-3xl font-bold text-white">{position}</span>
      </div>
    </PlainFrame>
  )
}
